<template>
  <div class="about_us">

    <div class="goTop" @click="handleGoTop">
      <img src="../assets/image/home/top_ic.png" alt="">
    </div>
    <div class="right_icon" @click="handleClose" @mouseover="lockOver(1)" @mouseout="lockOut">
      <img src="../assets/image/home/phone.png" alt="">
      <div :class="showLock===1?'text text-blue':'text'">{{currentPage=='home'?'客服电话':'咨询电话'}}</div>
    </div>
    <div class="contact_lock_1" :class="{'slide-left_lock':showLock===1}">
      <div v-if="showLock===1" >{{currentPage=='home'?'客服电话':'咨询电话'}} <span>0375-6033699</span></div>
    </div>
    <div class="right_icon" @click="handleClose" @mouseover="lockOver(2)" @mouseout="lockOut">
      <img v-if="currentPage=='home'" src="../assets/image/home/weChart.png" alt="">
      <img v-if="currentPage=='cooperation'" src="../assets/image/home/follow.png" alt="">
      <div :class="showLock===2?'text text-blue':'text'">{{currentPage=='home'?'微信公众号':'关注我们'}}</div>
    </div>
    <div class="contact_lock_2" :class="{'slide-left_lock2':showLock===2}">
      <div v-if="showLock===2">
        <div>关注我们：trxxkj</div>
        <img class="QR" src="../assets/image/home/qr.png" alt="">
      </div>
    </div>
    <!-- <div v-if="currentPage=='home'"  class="right_icon" @click="handleOnline" @mouseover="lockOver(3)" @mouseout="lockOut">
      <img src="../assets/image/home/online.png" alt="">
      <div :class="showLock===3?'text text-blue':'text'">在线客服</div>
    </div> -->
    <div  v-if="currentPage=='home'" class="contact_lock_3" :class="{'slide-left_lock3':showLock===3}">
      <div v-if="showLock===3">在线客服</div>
    </div>
    <div v-if="currentPage=='cooperation'"  class="right_icon" @click="tabOnlineMsg" @mouseover="lockOver(3)" @mouseout="lockOut">
      <img  src="../assets/image/home/join.png" alt="">
      <div :class="showLock===3?'text text-blue':'text'">加入我们</div>
    </div>
    <div  v-if="currentPage=='cooperation'" class="contact_lock_3" :class="{'slide-left_lock3':showLock===3}">
      <div v-if="showLock===3">加入我们</div>
    </div>
    <div  v-if="currentPage=='home'" class="right_icon" @click="tabOnlineMsg" @mouseover="lockOver(4)" @mouseout="lockOut">
      <img  src="../assets/image/home/serve.png" alt="">
      <div :class="showLock===4?'text text-blue':'text'">{{'服务咨询'}}</div>
    </div>
    <div  v-if="currentPage=='home'" class="contact_lock_4" :class="{'slide-left_lock4':showLock===4}">
      <div v-if="showLock===4">{{'服务咨询'}}</div>
    </div>


  </div>
</template>

<script>
    export default {
        name: "LeftFloatBtn",
        props:{
            currentPage:{
                type:String,
                default:'home'
            },
        },
        data(){
            return{
                showLock:null,
            }
        },
        methods:{
           async tabOnlineMsg() {
                let userInfo=JSON.parse(localStorage.getItem('userInfo'))
                if(userInfo){
                            window.location.href = "/index.html#/OnlineMsg";
                }else{
                    this.$message.warning('请登录后再进行咨询')
                    setTimeout(()=>{
                        window.location.href = "/login.html#/";
                    },1000)
                }



            },
            handleClose() {
                _AIHECONG('hideChat')
            },
            handleOnline() {
                _AIHECONG('showChat')
            },
            lockOut() {
                this.showLock = 0
            },
            lockOver(val) {
                this.showLock = val
            },
            handleGoTop() {
                cancelAnimationFrame(this.timer)
                const self = this
                self.timer = requestAnimationFrame(function fn() {
                    const oTop = document.body.scrollTop || document.documentElement.scrollTop
                    if (oTop > 0) {
                        document.body.scrollTop = document.documentElement.scrollTop = oTop - 50
                        self.timer = requestAnimationFrame(fn)
                    } else {
                        cancelAnimationFrame(self.timer)
                    }
                })
            },
        },
        mounted() {
            (function (d, w, c) {
                if (w[c]) return;
                var s = d.createElement("script");
                w[c] = function () {
                    (w[c].z = w[c].z || []).push(arguments);
                };
                s.async = true;
                s.src = "https://static.ahc.ink/hecong.js";
                if (d.head) d.head.appendChild(s);
            })(document, window, "_AIHECONG");
            _AIHECONG("ini", {channelId: "06zRvZ", button: false});
            // _AIHECONG("ini", {channelId: "9D0gHa", button: false});
            _AIHECONG('hideChat')


        }
    }
</script>

<style scoped lang="scss">

  .about_us {
    position: fixed;
    bottom: 80px;
    right: 40px;
    z-index: 666;
    min-height: 396px;
  .right_icon:hover {
    background: #f1f5ff;
    box-shadow: 0 4.79px 9.58px rgba(37, 91, 236, 0.14);
  }

  .right_icon {
    cursor: pointer;
    background: white;
    width: 68px;
    height: 68px;
    box-shadow: 0px 3px 6px rgba(52, 103, 189, 0.22);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

  img {
    width: 36px;
    height: 36px;
  }
    .text{
      font-weight: 400;
      font-size: 12px;
      line-height: 12px;
      text-align: left;
      color: #4e5969;
    }
    .text-blue{
      color: #0066FF;
    }
  }

  @keyframes slide-down {
    0% {
      transform: scaleY(0);
    }
    100% {
      transform: scaleY(1);
    }
  }

  @-webkit-keyframes slide-down {
    0% {
      -webkit-transform: scaleY(0);
    }
    100% {
      -webkit-transform: scaleY(1);
    }
  }

  .contact_lock_1 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: fixed;
    bottom: 288px;
    right: 113px;
    width: 0;
    background: #fff;
    padding-left: 20px;
    box-shadow: 0 4.79px 9.58px rgba(68, 120, 208, 0.22);
  /*transition: width .1s;*/

  div {
    font-weight: 400;
    font-family: "Microsoft YaHei";
    font-size: 14px;
    text-align: left;
    color: #1d2129;
    display: flex;
    flex-direction: column;

  span {
    font-family: "Microsoft YaHei Bold";
    font-weight: 700;
    font-size: 18px;
    text-align: left;
    color: #06f !important;
    margin-top: 12px;
  }
  }
  }

  .contact_lock_2 {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 156px;
    right: 113px;
    width: 0;
    height: 0;
    background: #fff;
    box-shadow: 0px 3px 6px rgba(68, 120, 208, 0.22);
  /*transition: width .1s, height .2s;*/

  div {
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1d2129;
  }

  .QR {
    margin-top: 8px;
    width: 76px;
    height: 76px;
  }
  }

  .contact_lock_3 {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 151px;
    right: 113px;
    width: 0;
    background: #fff;
    box-shadow: 0px 3px 6px rgba(68, 120, 208, 0.22);
  /*transition: width .1s;*/

  div {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1d2129;

  }
  }

  .contact_lock_4 {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 82px;
    right: 113px;
    width: 0;
    background: #fff;
    box-shadow: 0px 3px 6px rgba(68, 120, 208, 0.22);
  /*transition: width .1s;*/

  div {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1d2129;

  }
  }

  .slide-left_lock2 {
    width: 134px;
    height: 128px;
    /*transition: width .2s, height .2s;*/
    /*animation: slide-down 0.1s ease-in;*/
    /*-webkit-animation: slide-down 0.1s ease-in;*/
  }

  .slide-left_lock {
    width: 180px;
    height: 64px;
    /*transition: width .2s;*/
    /*animation: slide-down 0.1s ease-in;*/
    /*-webkit-animation: slide-down 0.1s ease-in;*/
  }

  .slide-left_lock3 {
    width: 110px;
    height: 64px;
    /*transition: width .2s;*/
    /*animation: slide-down 0.1s ease-in;*/
    /*-webkit-animation: slide-down 0.1s ease-in;*/
  }

  .slide-left_lock4 {

    height: 64px;
    width: 110px;
    /*transition: width .2s;*/
    /*animation: slide-down 0.1s ease-in;*/
    /*-webkit-animation: slide-down 0.1s ease-in;*/
  }

  .goTop {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 42px;
    width: 68px;
    height: 68px;
    opacity: 1;
    margin-bottom: 18px;
    border-radius: 13px;
    background: #165dff;
    box-shadow: 0 4.79px 9.58px rgba(68, 120, 208, 0.22);

  img {
    width: 36px;
    height: 36px;
  }
  }
  }
</style>
